import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d4261efe"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "column-modal"
}
const _hoisted_2 = { class: "modal-window" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "danger is-center" }, [
  /*#__PURE__*/_createTextVNode("無料会員登録を行い、ログインした状態でアクセスいただくと"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("ダウンロードいただけます。")
], -1))
const _hoisted_5 = { class: "is-center" }
const _hoisted_6 = ["href"]
const _hoisted_7 = { class: "is-center" }
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", null, [
    _createElementVNode("a", {
      class: "link",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.open && _ctx.open(...args)))
    }, "プレビュー"),
    (_ctx.state.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: "modal modal-overlay",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("a", {
                    class: "button is-success",
                    href: _ctx.props.signupPath
                  }, "無料会員登録はこちら", 8, _hoisted_6)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("a", {
                    class: "button is-success",
                    href: _ctx.props.signinPath
                  }, "ログインはこちら", 8, _hoisted_8)
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}